import { enums, formatters } from "@fraction/shared";

export const DROPDOWN_LABEL = "Income type";
export const FORM_FLOW_PAGE_TITLE = "What type of income is it?";
export const FORM_FLOW_PAGE_DESCRIPTION =
  "Is the income from an employer, self-employed income, or another source?";

export const INCOME_TYPES_SHARED: enums.IncomeType[] = [
  enums.IncomeType.EMPLOYMENT_INCOME,
  enums.IncomeType.SELF_EMPLOYMENT_INCOME,
  enums.IncomeType.PENSION_INCOME,
  enums.IncomeType.RENTAL_INCOME,
  enums.IncomeType.GOVERNMENT_BENEFITS_INCOME,
  enums.IncomeType.ALIMONY_AND_CHILD_SUPPORT,
  enums.IncomeType.BONUS_AND_COMMISSION,
  enums.IncomeType.SAVINGS_AND_INVESTMENTS,
  enums.IncomeType.OTHER,
];

// Some of the labels could be too long for the <IllustrativeOptions> which we use here,
// so we make a shortened copy here just for this component.
const INCOME_TYPE_MAP_SHORTENED = {
  ...formatters.enums.INCOME_TYPE_MAP,
  [enums.IncomeType.SAVINGS_AND_INVESTMENTS]: "Savings and investments",
};

export const mapIncomeTypesToOptions = (incomeTypes: enums.IncomeType[]) =>
  incomeTypes.map((type) => ({
    value: type,
    // @ts-ignore
    label: INCOME_TYPE_MAP_SHORTENED[type],
  }));
